(function() {
    document.querySelectorAll('[data-adev-variant-based-text="item"]:not(.adev-init)').forEach(item => {
        item.classList.add('adev-init');
        const text = item.querySelector('[data-adev-variant-based-text="text"]');
        const data = JSON.parse(item.querySelector('script').innerHTML);

        const updateText = (variant) => {
            const variantData = data.find(v => v.id == variant.id);
            if (variantData) {
                if (variantData.text && variantData.text !== '') {
                    text.innerHTML = variantData.text;
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            }
        };

        document.addEventListener('adev:variant_changed', (e) => {
            if (e && e.detail) {
                updateText(e.detail);
            }
        });
    });
})();